<div  *ngIf="loader" class="spinner-wrapper">
    <mis-loader [mobileView]="false"></mis-loader>
</div>
<div  *ngIf="!loader" class="main d-flex">
<app-side-bar></app-side-bar>
<app-map-view></app-map-view>
</div>